import type {
    DriverRechargeMetricsInput,
    FinanceTopupDoneClickEvent,
    FinanceTopupDoneRedirectEvent,
    FinanceTopupDoneRedirectPaymentMethod,
    FinanceTopupMethodChangedClickEvent,
    FinanceTopupSumClickEvent,
    FinanceTopupSumErrorEvent,
    FinanceTopupTagSumClickEvent,
    FinanceTopupViewEvent,
} from './types-metrics'

// finance_topup_view
export const buildFinanceTopupViewEvent = (
    input: DriverRechargeMetricsInput,
    amountValue: number,
    source: string,
): FinanceTopupViewEvent => {
    return {
        payment_method: input.paymentMethodDefault,
        balance_value: input.balanceValue,
        view_form: input.growthExperiment,
        sum_value: amountValue,
        tags_sum: input.tagsSum,
        source,
    }
}

// finance_topup_sum_click
export const buildFinanceTopupSumClickEvent = (
    clickFrom: 'button' | 'placeholder',
): FinanceTopupSumClickEvent => {
    return {
        click_from: clickFrom,
    }
}

// finance_topup_sum_error
export const buildFinanceTopupSumErrorEvent = (error: string): FinanceTopupSumErrorEvent => {
    return {
        error: error,
    }
}

// finance_topup_tag_sum_click
export const buildFinanceTopupTagSumClickEvent = (
    paymentMethod: string,
    input: DriverRechargeMetricsInput,
    selectedAmount: number,
    amountValue: number,
): FinanceTopupTagSumClickEvent => {
    return {
        payment_method: paymentMethod,
        balance_value: input.balanceValue,
        view_form: input.growthExperiment,
        sum_value: amountValue,
        sum_value_tag: selectedAmount,
        tags_sum: input.tagsSum,
    }
}

// finance_topup_method_changed_click
export const buildFinanceTopupMethodChangedClickEvent = (
    paymentMethod: string,
): FinanceTopupMethodChangedClickEvent => {
    return {
        payment_method: paymentMethod,
    }
}

// finance_topup_done_click
export const buildFinanceTopupDoneClickEvent = (
    input: DriverRechargeMetricsInput,
    paymentMethod: string,
    amountValue: number,
    selectedTagAmount: null | number,
    error: string | undefined,
): FinanceTopupDoneClickEvent => {
    return {
        payment_method: paymentMethod,
        balance_value: input.balanceValue,
        view_form: input.growthExperiment,
        ...(error === undefined ? {} : { error: error }),
        sum_value: amountValue,
        ...(selectedTagAmount === null ? {} : { sum_value_tag: selectedTagAmount }),
        tags_sum: input.tagsSum,
    }
}

// finance_topup_done_redirect
const mapPaymentMethodToDoneRedirect = (
    paymentMethodId: string,
): FinanceTopupDoneRedirectPaymentMethod => {
    switch (paymentMethodId) {
        case 'tbank-sbp': {
            return 'sbp'
        }
        case 'sberpay': {
            return 'sp'
        }
        case 'wallet-one': {
            return 'walletone'
        }
        default: {
            return 'card'
        }
    }
}

export const buildFinanceTopupDoneRedirectEvent = (
    input: DriverRechargeMetricsInput,
    paymentMethodId: string,
    amountValue: number,
    selectedTagAmount: null | number,
    paymentId: string,
): Omit<
    FinanceTopupDoneRedirectEvent,
    'app_version' | 'appsflyer_id' | 'city_id' | 'event_time' | 'user_id'
> => {
    return {
        payment_method: mapPaymentMethodToDoneRedirect(paymentMethodId),
        balance_value: input.balanceValue,
        view_form: input.growthExperiment,
        payment_id: paymentId,
        sum_value: amountValue,
        ...(selectedTagAmount === null ? {} : { sum_value_tag: selectedTagAmount }),
        tags_sum: input.tagsSum,
    }
}
